import React from "react";
import { PaymentElement } from "@stripe/react-stripe-js";
import { Button } from "@campgladiator/cgui-core.atoms.button";
import { Loader } from "@campgladiator/cgui-core.atoms.loader";
import usePaymentManagement from "../../hooks/usePaymentManagement";
import { PaymentMethods } from "../PaymentMethods";
import styles from "./PaymentManagementAddOrEdit.module.scss";

export type PaymentManagementAddOrEditProps = {
  stripeCustomerId: string;
  onError: (error: any) => void;
  onSelectPaymentMethod: (paymentMethodId: string) => void;
};

const PaymentManagementAddOrEdit = ({
  onError,
  stripeCustomerId,
  onSelectPaymentMethod,
}: PaymentManagementAddOrEditProps) => {
  const {
    paymentElementOptions,
    showPaymentMethods,
    paymentMethodsProps,
    onCancelAddingNewCard,
    onSubmitNewCard,
    isLoading,
  } = usePaymentManagement({
    stripeCustomerId,
    onError,
    onSelectPaymentMethod,
  });

  return (
    <form onSubmit={onSubmitNewCard}>
      {!showPaymentMethods && (
        <div className={styles.paymentElement}>
          <PaymentElement
            id="payment-element"
            options={paymentElementOptions}
          />
          <div>
            <Button
              emphasis="secondary"
              size="small"
              variation="text"
              onClick={onCancelAddingNewCard}
              disabled={isLoading}
            >
              {isLoading ? <Loader /> : "Cancel"}
            </Button>
            <Button
              size="small"
              emphasis="secondary"
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? <Loader /> : "Save Card"}
            </Button>
          </div>
        </div>
      )}
      {showPaymentMethods && <PaymentMethods {...paymentMethodsProps} />}
    </form>
  );
};

export default PaymentManagementAddOrEdit;
